<template>
  <path
    d="M7 3.00018V12.0002C7 12.5502 7.45 13.0002 8 13.0002H10V20.1502C10 20.6602 10.67 20.8402 10.93 20.4002L16.12 11.5002C16.51 10.8302 16.03 10.0002 15.26 10.0002H13L15.49 3.35018C15.74 2.70018 15.26 2.00018 14.56 2.00018H8C7.45 2.00018 7 2.45018 7 3.00018Z"
  />
</template>
